export const initMobileDesignsGallerySection = () => {
  const mobileGallerySection = document.querySelector(
    '.section--cb-mobile-designs-gallery',
  );

  if (!mobileGallerySection) {
    return; // No action needed if the element is not present
  }

  const windowWidth = window.innerWidth;
  const elementWidth = 220;
  const numElToAppend = Math.ceil(windowWidth / elementWidth) * 1;

  const parentElSelector = '.ticker-list';
  const elSelector = 'li';
  const parentEl = document.querySelector(parentElSelector);
  const itemEls = parentEl.querySelectorAll(elSelector);

  const totalElements = itemEls.length;
  const elementsToAppend = Math.min(numElToAppend, totalElements);
  let appendedElements = 0;
  let elementsAppended = 0;

  function appendClone() {
    parentEl.appendChild(
      itemEls[appendedElements % totalElements].cloneNode(true),
    );
    appendedElements += 1; // Replace the post-increment operator

    if (appendedElements >= elementsToAppend && elementsAppended === 0) {
      elementsAppended = appendedElements;
    }

    if (appendedElements - elementsAppended >= totalElements) {
      parentEl.removeChild(
        itemEls[(appendedElements - elementsAppended) % totalElements],
      );
    }

    if (appendedElements < elementsToAppend) {
      requestAnimationFrame(appendClone);
    }
  }

  if (elementsToAppend > 0) {
    requestAnimationFrame(appendClone);
  }
};
